export default "__VITE_ASSET__DaAx62Na__"